module.exports = __webpack_public_path__ + "static/media/alert-triangle-green-large.c9a1197e.svg";